import * as Icons from '@ant-design/icons';
import { AcademicRecordEdit } from './edit';
import { AcademicRecordInfo } from './components/AcademicRecordInfo';
import { AcademicRecordLogModal } from 'components/modal/academic-records/AcademicRecordLogModal';
import { Button, Typography } from 'antd';
import { IAcademicRecord } from 'interfaces/academic_record';
import { Show, useModal as useModalAntd } from '@refinedev/antd';
import { UpdateAttendanceModal } from 'components/modal/attendance/UpdateAttendanceModal';
import { disciplineModulesKind } from 'pages/graduate_courses/components/TabDisciplines';
import { useCallback, useMemo, useState } from 'react';
import { useCan, useModal, useShow } from '@refinedev/core';
import { useDisciplineModules } from 'hooks/useDisciplineModules';
import { useParams } from 'react-router-dom';

export const AcademicRecordShow = () => {
  const [toBeUpdated, setToBeUpdated] = useState<IAcademicRecord>();
  const {
    show: showAttendanceModal,
    modalProps: attendanceModalProps,
    close: closeAttendanceModal
  } = useModalAntd();
  const { id } = useParams();
  const { queryResult } = useShow<IAcademicRecord>({
    resource: 'graduate/academic_records',
    id,
    errorNotification: {
      type: 'error',
      message: 'Erro ao carregar dados. Tente novamente!'
    }
  });
  const { data, isLoading, refetch } = queryResult;
  const record = data?.data;

  const { data: canEdit } = useCan({
    resource: 'graduate_academic_records',
    action: 'edit'
  });
  const editScoreModal = useModal();
  const showLogModal = useModal();

  const disciplineModules = useDisciplineModules({
    filters: {
      by_course: record?.course_enrollment.course.id
    }
  }).data?.data;

  const disciplineModule = useMemo(() => {
    if (record && disciplineModules?.length) {
      return disciplineModules.find(
        dm => dm.discipline.id === record.discipline.id
      );
    }
  }, [disciplineModules, record]);

  const handleUpdateAttendanceRate = useCallback(() => {
    setToBeUpdated(record);
    showAttendanceModal();
  }, [record, showAttendanceModal]);

  return (
    <>
      <Show
        isLoading={isLoading}
        title="Visualizar histórico acadêmico"
        headerButtons={
          <>
            {canEdit?.can && (
              <Button
                icon={<Icons.EditOutlined />}
                onClick={handleUpdateAttendanceRate}
                disabled={record?.status === 'exempted'}
              >
                Editar frequência
              </Button>
            )}
            {canEdit?.can && (
              <Button
                icon={<Icons.EditOutlined />}
                onClick={editScoreModal.show}
                disabled={record?.status === 'exempted'}
              >
                Editar nota
              </Button>
            )}

            <Button icon={<Icons.EyeOutlined />} onClick={showLogModal.show}>
              Visualizar alterações
            </Button>
          </>
        }
      >
        {!record ? (
          <Typography.Text>Nenhuma informação encontrada</Typography.Text>
        ) : (
          <AcademicRecordInfo
            record={record}
            kindLabel={
              disciplineModulesKind[
                disciplineModule?.kind as keyof typeof disciplineModulesKind
              ]
            }
          />
        )}
      </Show>

      {record && editScoreModal.visible && (
        <AcademicRecordEdit modal={editScoreModal} academicRecord={record} />
      )}

      {record && showLogModal.visible && (
        <AcademicRecordLogModal
          modal={showLogModal}
          academicRecordId={record.id}
        />
      )}
      <UpdateAttendanceModal
        modalClose={closeAttendanceModal}
        modalProps={attendanceModalProps}
        refetch={refetch}
        resourceType="AcademicRecord"
        academicRecords={toBeUpdated}
      />
    </>
  );
};
